import { MatSnackBar } from '@angular/material/snack-bar';
import Swal from 'sweetalert2';

export function showMatSnackMessage(snackBar: MatSnackBar,
  message: string,
  duration: number = 3000,
  cssClass: string = 'snackbar-custom'): void {
  snackBar.open(message, 'Cerrar', {
    duration,
    horizontalPosition: 'right',
    verticalPosition: 'bottom',
    panelClass: [cssClass],
  });
}


export function alertConfirmHTML(icon: any,
  titulo: string,
  texto: string,
  botonCancelar: boolean,
  textoConfirmar: string,
  textoCancelar: string): Promise<boolean> {
  return new Promise((resolve) => {
    Swal.fire({
      icon: icon,
      title: titulo,
      html: texto,
      confirmButtonText: textoConfirmar,
      showCancelButton: botonCancelar,
      cancelButtonText: textoCancelar
    }).then((result) => {
      if (result.isConfirmed) {
        resolve(true)
      } else {
        resolve(false)
      }
    })
  })
}